import { getRelativeTime } from '@thoughtspot/date-format-util';
import { isOktaEnabled } from '@thoughtspot/system-config-service';
import _ from 'lodash';
import { useEffect, useState } from 'react';
import { isFreeTrialOrTeamOrDeveloperUser } from './util';
export const useDataHooks = (useGetUsersListPrincipalQuery, isRefreshed, userListInput, setIsLoading, setIsRefresh, currentOrgId) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const { data: usersList, error: usersListError, loading: usersListLoading, refetch: refreshUsersList, } = useGetUsersListPrincipalQuery({ ...userListInput });
    useEffect(() => {
        if (isRefreshed) {
            refreshUsersList({ ...userListInput });
            setIsRefresh(false);
        }
    }, [isRefreshed]);
    useEffect(() => {
        try {
            if (usersList && !usersListLoading) {
                const userData = _.cloneDeep(usersList);
                const parseData = userData.objects.map((user) => {
                    if (isOktaEnabled()) {
                        const { id, displayName, name, created, statistics, } = user;
                        const userState = statistics.userState;
                        return {
                            id,
                            userName: {
                                text: name || '',
                            },
                            userDisplayName: {
                                text: displayName,
                            },
                            userCreated: {
                                text: getRelativeTime(created),
                            },
                            userState: {
                                text: userState,
                            },
                            isChecked: false,
                        };
                    }
                    const { id, displayName, name, created, statistics } = user;
                    const baseUserData = {
                        id,
                        userName: {
                            text: name || '',
                        },
                        userDisplayName: {
                            text: displayName,
                        },
                        userCreated: {
                            text: getRelativeTime(created),
                        },
                        isChecked: false,
                    };
                    if (isFreeTrialOrTeamOrDeveloperUser()) {
                        const userState = statistics.userState;
                        return {
                            ...baseUserData,
                            userState: {
                                text: userState,
                            },
                        };
                    }
                    return baseUserData;
                });
                setData(parseData);
                setLoading(false);
                setIsLoading(false);
                setIsRefresh(false);
            }
        }
        catch (err) {
            setError(true);
            setLoading(false);
            setIsLoading(false);
            setIsRefresh(false);
        }
    }, [usersList, userListInput, usersListLoading]);
    return {
        data,
        loading,
        error,
        isLastBatch: usersList?.isLastBatch || false,
    };
};
//# sourceMappingURL=useDataHook.js.map